<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="5">
          <b-form-group
            description="Choose from different themes for the card images."
          >
            <label>Theme Selection:</label>
            <b-form-select
              id="match-groups"
              v-model="settingsUser.matchGroup"
              :options="themes"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
            description="Select the size of the card grid, including options like 4x4, 6x6, or other grid dimensions. Larger grids can be more challenging."
          >
            <label>Card Grid Size:</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.gridSize"
              :min="gridSizeMin"
              :max="gridSizeMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
export default {
  name: "Settings_MatchGame",
  components: {},
  mixins: [ResourceBlockSettings],
  methods: {},
  data() {
    return {
      settingsUser: {
        gridSize: 2,
        theme: "clouds"
      },
      toggles: [
        {
          name: "Shufflw",
          description: "Sound effects during gameplay",
          property: "isSoundOn",
          type: "btns",
          text: "Turn on the Sound",
          isAvail: true,
          value: true
        },
        {
          name: "Background Music",
          description: "Play Background Music during GamePlay",
          property: "hasBGMusic",
          type: "btns",
          text: "Turn on the Sound",
          isAvail: true,
          value: false
        },
        {
          name: "Progress Stats",
          property: "isDisplayStats",
          type: "btns",
          text: "Display their turns, times, scores ",
          isAvail: true,
          value: true
        }
      ],
      //****** App Specific
      gridSizeMin: 2,
      gridSizeMax: 5,
      themes: [
        { value: "clouds", text: "Clouds" },
        { value: "church", text: "Church" },
        { value: "animals", text: "Animals" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
